import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { DetailsPage as StepDetailsPage } from 'src/app/steps/details/details.page';
import { AutomaticStepTypes } from '../StepTypes';
import * as dayjs from 'dayjs';
import { GlobalService } from 'src/app/api/global.service';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-step-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {

  loaded_steps: boolean = false;
  @Input() steps: any = null;
  companies: any = null;
  user: any = null;
linkedToOptions: any[] = [];

  @Output() stepModified = new EventEmitter<{data: any}>();
  today: Date;

  

  constructor(
    private modalController: ModalController,
    private apiService: ApiService,
    private globalService: GlobalService,
    private router: Router
  ) {}

  ngOnInit() {
    this.GetData();

    console.log(this.steps);
    this.today = dayjs().toDate();
  }

  async GetData() {
    this.loaded_steps = false;
    await this.GetUser();
    await this.GetCompanies();
    await this.FormatData();
    this.loaded_steps = true;
  }

  async GetCompanies() {
    let data: any = await this.apiService.get(`companies`);
    if(data.success) {
      this.companies = data.data;
    }
  }
  async GetUser() {
    this.user = await this.globalService.GetUser();
    console.log(this.user);
  }

  async FormatData() {
    for(let step of this.steps) {
      step.linked_to = this.GetStepLinkedTo(step);
      step.due_date_ts = step.due_date ? new Date(step.due_date).getTime() : 0;
    }
    this.BuildLinkedToOptions();
  }


  async presentStepDetails(step) {
    console.log("Present Step Details", step);
    const modal = await this.modalController.create({
      component: StepDetailsPage,
      cssClass: 'fullscreen-modal',
      backdropDismiss: false,
      componentProps: {
        step: step
      },
    })
     modal.onDidDismiss()
      .then((data) => {
        this.stepModified.emit({data: true});
      });
    return await modal.present()
  }

  GetStepLinkedTo(step) {
    if(!this.companies) return "";
    if(step.company_guid) {
      let company = this.companies.find(c => c.guid == step.company_guid);
      return company.name;
    }
    else {
      return this.user.display_name;
    }
    
  }

  GetEmailSubject(step) {
    if (!step.emails || step.emails.length === 0) return '';
    return step.emails[0].subject || '';
  }

  ShowProjectTitle(): boolean {
    return !!this.steps?.some(s => !!s.project_title);
  }

  GetProjectTitle(step) {
    return step.project_title || '';
  }

  presentStepComplete(step) {
    console.log(step);
    this.router.navigate(['/email'], { queryParams: { guid: step.emails[0].guid } });
  }

  BuildLinkedToOptions() {
    this.linkedToOptions = [];
    
    // Add current user
    if(this.user) {
      this.linkedToOptions.push({
        label: this.user.display_name,
        value: this.user.display_name
      });
    }
    
    // Add all companies
    if(this.companies) {
      this.companies.forEach(company => {
        this.linkedToOptions.push({
          label: company.name,
          value: company.name
        });
      });
    }
  }



}
